import { Button, Tooltip } from "antd";
import React from "react";
import { isTransferInFlight, useOptionalTransfer } from "../../components/TransferButton/TransferContext";
import { useAppSelector } from "../../hooks/redux-hooks";
import styles from "./notes.module.scss";

const SaveButton = ({ onClick, style }: { onClick: () => void; style?: React.CSSProperties }) => {
  const componentName = "notes";
  const { isDemoPath } = useAppSelector((state) => state.appState);
  const { notesDetails } = useAppSelector((state) => state.notes);
  // The in-flight transfer writes the click-time snapshot, so a mid-flight
  // save would change the Nudge note but silently never reach the chart —
  // hold Save (typing stays live) until the transfer is terminal.
  const transfer = useOptionalTransfer();
  const job = notesDetails && transfer ? transfer.getJobForAudio(notesDetails.id) : null;
  const transferring = isTransferInFlight(job?.status);
  return (
    <div className={`${styles[`${componentName}__main-section-action`]}`} style={style}>
      {!isDemoPath && (
        <Tooltip title={transferring ? "Transfer in progress — you can save when it completes." : undefined}>
          {/* span wrapper: a disabled antd Button swallows hover events, so the
              tooltip needs an enabled element to anchor to. */}
          <span>
            <Button
              type="primary"
              onClick={onClick}
              disabled={transferring}
              className={`${styles[`${componentName}__main-section-save-button`]}`}
            >
              Save Changes
            </Button>
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default SaveButton;
